import {CloneFactory} from './CloneFactory';
import {FadeAnimation} from './animations/FadeAnimation';
import {WidthAnimation} from './animations/WidthAnimation';
import {GroupAnimation} from './animations/GroupAnimation';

declare var callback:any;
declare var Drupal:any;

export class AjaxSearch {

    private post:any;
    private results:JQuery<HTMLElement>
    private form:JQuery<HTMLFormElement>;
    private action:string;

    constructor(private container:JQuery<HTMLElement>) {
        this.form=container.find('form');
        let action=this.form.attr('action');
        if (!action) throw "No action defined.";
        this.action = action;
        this.results=container.find('.search-results');
        this.form.on('submit',ev=>this.submit(ev));
        this.form.on('reset',ev=>this.reset(ev));
        this.form.addClass('is-ajax');
        this.post=this.getFormData();
        this.post['page']=1;
        this.results.find(".more-bar button").on("click keydown",(ev)=>this.moreEvent(ev));
    }

    private getFormData() {
        let data=this.form.serializeArray();
        let result:any={};
        for (let item of data) {
            let key=item.name;
            let val=item.value;
            if (['form_token'].includes(key)) continue;
            if (key.endsWith('[]')) {
                key=key.slice(0,-2);
                if (result[key]===undefined) result[key]=[];
                result[key].push(val);
            } else {
                result[key]=val;
            }
        }
        return result;
    }

    private submit(ev:JQuery.TriggeredEvent) {
        ev.preventDefault(); //preventDefault needs to happen in the non-sync-part for iOS
        this.asyncSubmit();
    }

    private async asyncSubmit() {
        if (document.activeElement instanceof HTMLInputElement) document.activeElement.blur();
        this.post=this.getFormData();
        this.setPostData(this.post);
        delete this.post['form_token'];
        this.container.addClass('searching');
        this.form.find('[type="submit"]:is(input,button)').addClass('loading');
        this.post['page']=1;
        let html=await callback({url: this.action, post: this.post, action: 'none'});
        let oldTerms = this.results.find('.terms').children();
        let newTerms = $($.parseHTML(html)).find('.terms').children();
        let removed  = this.compare(oldTerms, newTerms);
        let added    = this.compare(newTerms, oldTerms);

        await this.playAnimation(added, removed);

        let searchHeader=$('.search-header');

        let cf;
        if (searchHeader.length) {
            cf=new CloneFactory();
            let search_header_clone=cf.clone(searchHeader);
            search_header_clone.css('position','absolute');
            search_header_clone.css('top',window.scrollY+parseFloat(search_header_clone.css('top')));
        }

        await new FadeAnimation(this.results).to(0).play().promise('end');
        this.results.replaceWith(html);
        this.results=this.container.find('.search-results');
        Drupal.attachBehaviors(this.results[0]);
        let hasHits=!!this.results.find('.hits .hit').length;
        this.results.find(".more-bar a,.more-bar button").on("click",(ev)=>this.moreEvent(ev));
        $('.search-results').find('.search-header').css('visibility','hidden');

        await new FadeAnimation(this.results).from(0).to(1).play().promise('end');

        Drupal.attachBehaviors(this.results[0]);
        this.form.find('[type="submit"]:is(input,button)').removeClass('loading');
        this.container.removeClass('searching');
        cf?.destroy();
        $('.search-results').find('.search-header').css('visibility','');
    }

    private async playAnimation(added:HTMLElement[], removed:HTMLElement[]) {
        await this.addTerms(added);
        await this.removeTerms(removed);

    }

    private async addTerms(terms:HTMLElement[]) {
        let oTermsChildren = $('.terms').children();
        let oTerms = $('.terms');
        let anims=[];

        if (!oTermsChildren.length) {
            for (let term of terms) {
                let nTerm = $(term);
                oTerms.append(nTerm);
                nTerm = oTerms.children().last();
                anims.push(new WidthAnimation(nTerm).from(0));
            }
        } else {
            for (let term of terms) {
                let nTerm = $(term);
                let found = false;

                for (let child of oTermsChildren) {
                    let oTerm = $(child);
                    if (oTerm.data('weight') > nTerm.data('weight')) {
                        oTerm.before(nTerm);
                        nTerm = oTerm.prev();
                        anims.push(new WidthAnimation(nTerm).from(0));
                        found = true;
                        break;
                    }
                }

                if (!found) {
                    oTermsChildren.last().before(nTerm);
                    nTerm = oTermsChildren.last().prev();
                    anims.push(new WidthAnimation(nTerm).from(0));
                }
            }
        }

        await new GroupAnimation(...anims).play().promise('end');
    }


    private async removeTerms(terms:HTMLElement[]) {
        let oldTerms = $('.terms').children();
        let removed = [];

        let anims=[];

        for (let term of terms) {
            let nTerm = $(term);

            for (let oldTerm of oldTerms) {
                let oTerm = $(oldTerm);
                if (oTerm.data('term') === nTerm.data('term')) {
                    removed.push(oTerm);
                    //anims.push(new FadeAnimation(oTerm).to(0));
                    anims.push(new WidthAnimation(oTerm).to(0));
                    continue;
                }
            }
        }

        await new GroupAnimation(...anims).play().promise('end');
        removed.forEach(x=>x.remove());
    }

    private compare(a:JQuery<HTMLElement>, b:JQuery<HTMLElement>) {
        let differences:HTMLElement[] = [];

        for (let cur_a of a) {
            let match = 0;
            for (let cur_b of b) {
                if (cur_a.isEqualNode(cur_b)) {
                    match++;
                }
            }
            if (match === 0) {
                differences.push(cur_a);
            }
        }

        return differences;
    }

    private async moreEvent(ev:JQuery.TriggeredEvent) {
        if(ev.type == 'keydown' && ev.which != 32 && ev.which != 13) return;
        ev.preventDefault();

        var e=$(ev.target);
        this.post['page']++;
        $(ev.currentTarget).addClass('loading');
        let html=await callback({url: this.action, post: this.post, action: 'none'});
        $(ev.currentTarget).removeClass('loading');
        let newhtml=$(html);
        let isLast=!!newhtml.find(".hit-last").length;
        let newhits=newhtml.find(".hits");
        let allhits=this.results.find(".all-hits");
        allhits.append(newhits);
        if (isLast) e.closest(".more-bar").hide();
        Drupal.attachBehaviors(this.results[0]);
        $(newhits.find(".hit :focusable:not([tabindex='-1'])")[0]).focus();
    }

    private setPostData(formData:any) {
        if (this.form.hasClass('skip-history')) return;

        let query = '';

        let elements=<JQuery<HTMLFormElement>>this.form.find('input[type="text"],select');
        for (let element of elements) {
            let name=element.name.replace(/\[\]$/,'');
            if (formData[name]) query = this.buildQuery(query,name,formData[name]);
        }

        let newurl= location.pathname + query;

        history.replaceState(history.state,'',newurl);
    }

    private buildQuery(queryString:string,key:string,value:string|string[]) {
        queryString = queryString != ''?queryString + "&":queryString + "?";
        if(typeof value == 'string') {
            queryString += key + '=' + encodeURIComponent(value);
        } else if(value instanceof Array){
            queryString += key + '[]=' + value.map(encodeURIComponent).join("&" + key + "[]=");
        }

        return queryString;
    }

    public reset(ev:JQuery.TriggeredEvent) {
        ev.preventDefault();

        let inputs=this.form.find('input:not([type="submit"]):not([type="reset"])');
        inputs.val('');
        inputs.trigger('change');

        let checkboxes = this.form.find('input[type="checkbox"]');
        checkboxes.prop('checked', false);
        checkboxes.trigger('change');

        let dateInputs=this.form.find('.date-widget');
        for (let input of dateInputs) {
            $(input).children().val('');
        }

        let selects=this.form.find('select');
        selects.val([]);
        selects.trigger('change');

        this.form.trigger('cleared');

        this.post=this.getFormData();
        this.setPostData(this.post);
        this.submit(ev);
    }

}

export {};